const {qsa,build}=require('../../libs/qs')
const fxs=require('./fx')
const pipeline=[]
const lib={
    tick:250,
    animate:false,
    isDrawing:false,
    pendingDraw:null,
    currentFx: null,
    listeners: {},
    imageProcessor: null,
    useWorker: true,
    workerReady: false,

    async initWorker() {
        if (typeof ImageProcessor !== 'undefined' && lib.useWorker) {
            lib._initWorkerInternal()
        } else {
            let attempts = 0
            const maxAttempts = 50
            const waitForImageProcessor = () => {
                return new Promise((resolve) => {
                    const check = () => {
                        attempts++
                        if (typeof ImageProcessor !== 'undefined') {
                            resolve()
                        } else if (attempts >= maxAttempts) {
                            resolve()
                        } else {
                            setTimeout(check, 100)
                        }
                    }
                    check()
                })
            }
            await waitForImageProcessor()
            if (typeof ImageProcessor !== 'undefined') {
                lib._initWorkerInternal()
            }
        }
    },

    _initWorkerInternal: async function() {
        try {
            lib.imageProcessor = new ImageProcessor()
            lib.workerReady = await lib.imageProcessor.init()
        } catch (e) {
            lib.workerReady = false
        }
    },

    on(event, callback) {
        if (!this.listeners[event]) this.listeners[event] = []
        this.listeners[event].push(callback)
    },

    emit(event, data) {
        if (this.listeners[event]) {
            this.listeners[event].forEach(cb => cb(data))
        }
    },

    reloadPipeline:async()=>{
        pipeline.length = 0

        const checkboxes=qsa(".switch")

        qsa('.fxcontent').forEach((el, idx) => {
            let inputs = []

            const inpts=qsa(`.${el.dataset.uid}`)
          
            inpts.forEach((el,idx)=>{
                inputs.push(el.value)
            })

            let fx=null

            for(let _fx of fxs){
                if(_fx.name==el.dataset.type){
                    fx=_fx
                }
            }

            pipeline.push({
                id: el.dataset.id,
                type: el.dataset.type,
                inputs: inputs,
                ison:checkboxes[idx].checked,
                fx:fx.fn
            })
        })
    },

    Draw:async(outctx,originalimg)=>{
       
        if (!originalimg || !originalimg.width || !originalimg.height || originalimg.width <= 0 || originalimg.height <= 0) {
            return false
        }
        
        const canvas = build('canvas')
        const ctx = canvas.getContext("2d")
    
        lib.reloadPipeline()
        if (lib.isDrawing) {
            lib.pendingDraw = { outctx, originalimg }

            if (lib.imageProcessor && typeof lib.imageProcessor.pendingCount === 'function' && lib.imageProcessor.pendingCount() > 0) {
                lib.imageProcessor.cancelCurrentPipeline('Pipeline superseded by newer request')
                    .catch(() => {})
            }
            return false
        }

        const activeCount = pipeline.filter(f => f.ison).length
        
        if (activeCount === 0) {
            outctx.drawImage(originalimg, 0, 0, originalimg.width, originalimg.height)
            return false
        }

        lib.emit('start', { total: activeCount })
        lib.isDrawing = true
        const W = originalimg.width
        const H = originalimg.height

        canvas.width = W
        canvas.height = H
        outctx.drawImage(originalimg, 0, 0, W, H)
        ctx.drawImage(originalimg, 0, 0, W, H)

        try {
            if (lib.workerReady && lib.imageProcessor) {
                const activeFxList = pipeline.filter(f => f.ison).map(fx => ({ fxName: fx.type, args: fx.inputs }))
                if (activeFxList.length > 0) {
                    for (let i = 0; i < activeFxList.length; i++) {
                        lib.currentFx = activeFxList[i].fxName
                        lib.emit('fxstart', { fx: activeFxList[i].fxName, index: i, total: activeFxList.length })
                    }
                    const imageData = ctx.getImageData(0, 0, W, H)
                    const result = await lib.imageProcessor.processBatch(activeFxList, imageData.data, W, H)
                    const newImageData = new ImageData(new Uint8ClampedArray(result.data), result.width, result.height)
                    ctx.putImageData(newImageData, 0, 0)
                }
            } else {
                throw new Error('Worker not ready, cannot process FX')
            }

            outctx.drawImage(canvas,0,0,W,H)
        } catch (error) {
            outctx.drawImage(originalimg, 0, 0, W, H)
            lib.emit('error', { error, fx: lib.currentFx })
        } finally {
            lib.currentFx = null
            lib.emit('fxend')
            lib.isDrawing = false
            lib.emit('complete')

            if (lib.pendingDraw) {
                const nextDraw = lib.pendingDraw
                lib.pendingDraw = null
                setTimeout(() => {
                    lib.Draw(nextDraw.outctx, nextDraw.originalimg)
                }, 0)
            }
        }
    }
}

module.exports=lib
